import { render } from "./Table.vue?vue&type=template&id=f622ae5c&ts=true"
import script from "./Table.vue?vue&type=script&lang=ts&setup=true"
export * from "./Table.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Orchard/LeavesData/Table.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f622ae5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f622ae5c', __exports__)) {
    console.log('reload')
    api.reload('f622ae5c', __exports__)
  }
  
  module.hot.accept("./Table.vue?vue&type=template&id=f622ae5c&ts=true", () => {
    console.log('re-render')
    api.rerender('f622ae5c', render)
  })

}


export default __exports__